import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { ProjectsService } from 'src/app/services/projects.service';
import { MainService } from 'src/app/services/main.service';
import { CutoffService } from 'src/app/services/cutoff.service';
import { InventorysService } from 'src/app/services/inventory.service';

@Component({
  selector: "app-project-diagramation-import-summary",
  templateUrl: "./project-diagramation-import-summary.component.html",
  styleUrls: ["./project-diagramation-import-summary.component.scss"]
})
export class ProjectDiagramationImportSummaryComponent implements OnInit {
  diagrams: any[] = [];
  completedDiagrams: any[] = [];
  alertsDiagrams: any[] = [];
  errorDiagrams: any[] = [];
  pendingDiagrams: any[] = [];
  unconfirmedDiagrams: any[] = [];
  hasErrors: boolean = false;
  projectData: any;
  promos: any[] = [];
  phases: any[] = [];
  id_proy: number;
  id_proy_camp: number;
  projectAllDiagramations: any[] = [];
  selected_medios: any[] = [];
  selected_attributes: any[] = [];
  stopOnError: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ProjectDiagramationImportSummaryComponent>,
    private projectsS: ProjectsService,
    private main: MainService,
    private _cutoffS: CutoffService,
    private inventoryService: InventorysService
  ) {
    this.diagrams = data.diagrams;
    this.projectData = data.projectData;
    this.promos = data.promos;
    this.phases = data.phases;
    this.id_proy = data.id_proy;
    this.id_proy_camp = data.id_proy_camp;
    this.projectAllDiagramations = data.projectAllDiagramations;
    this.selected_medios = data.selected_medios;
    this.selected_attributes = data.selected_attributes;
    this.stopOnError = data.stopOnError;
  }

  ngOnInit(): void {
    this.completedDiagrams = this.diagrams.filter(d => d.status === "completed" && d.alerts.length === 0);
    this.alertsDiagrams = this.diagrams.filter(d => d.status === "alerts");
    this.errorDiagrams = this.diagrams.filter(d => d.status === "error" && d.savedId == null);
    this.unconfirmedDiagrams = this.diagrams.filter(d => d.status === "error" && d.savedId != null);
    this.pendingDiagrams = this.stopOnError
      ? this.diagrams.filter(d => d.status === "pending")
      : [];
    this.hasErrors = this.errorDiagrams.length > 0 || this.pendingDiagrams.length > 0;
  }

  showDiagramAlerts(diagram: any) {
    if (diagram.alerts.length === 0)
      return;
    const alertList = diagram.alerts.map((alert: string) => "<li>" + alert + "</li>").join("");
    Swal.fire({
      title: "Alertas para " + (diagram.alias || "diagramación"),
      html: "<ul style=\"text-align: left; margin-left: 20px;\">" + alertList + "</ul>",
      icon: "warning",
      confirmButtonText: "Aceptar"
    });
  }

  showDiagramError(diagram: any) {
    if (!diagram.error)
      return;
    Swal.fire({
      title: "Error en " + (diagram.alias || "diagramación"),
      html: "<p style=\"text-align: left; margin-left: 20px;\">" + diagram.error + "</p>",
      icon: "error",
      confirmButtonText: "Aceptar"
    });
  }

  retryFailedDiagrams() {
    const diagramsToRetry = [...this.errorDiagrams, ...this.pendingDiagrams]
      .filter(d => d.savedId == null)
      .map(d => ({ ...d, status: "pending", error: null, alerts: [], isSaving: false }));
    this.dialogRef.close({ retryDiagrams: diagramsToRetry });
  }

  close() {
    this.dialogRef.close({ reload: true });
  }
}
